export enum Stage {
  LOCAL = "local",
  DEV = "dev",
  APPR = "appr",
  APPREX = "apprex",
  PROD = "prod",
}
